import {Constants} from "../../Constants/Constant"
import moment from 'moment'


export const mapInternalStatusToColor = {
        '154dcbf5-2ee8-b60d-9f0d-3709944337bd':['#9a0000','#fff'],
        '3f23bff3-97b9-4b5c-bda8-642ece31c698':['#c44028','#b6d7a8'],
        'ffb4f463-33f1-4d05-9575-413f9f58cde7':['#dd7e6a',''],
        '957e2962-ab02-4ceb-a57e-04bff9003682':['#e7b8b0',''],
        'fc1a6143-389e-4474-8404-248b27af9867':['#0d5290','#fff'],
        '98d24789-d38d-4426-b6bc-1be53a18fb80':['#fff',''],
        '154dcbf5-2ee8-b60d-9f0d-4709944337bd':['#fff',''],
        'ccefb0de-fc2b-4a46-8e3f-996f04f40351':['#3e85c7','#fff'],
        '4b874954-4da5-4002-bbb7-52ba954c9b38':['#6ca8de',''],
        '00fb7496-c2f1-4361-b653-9507419d2096':['#a1c5e7',''],
        '15fae42a-f0d7-4f84-a995-a2d833864cbe':['#2d7428','#fff'],
        '0d61b7c8-c508-42b4-8da6-ef087e68ea05':['#cee0f4',''],
        'b3dc515a-9757-4f04-90c9-72860f32b4b3':['#b4d8a8',''],
        'bcd55c8e-76f1-410b-ae50-51931ed987bf':['#76a5af',''],
        'ea40091b-fb89-4774-ab6d-ec34e638957e':['#a2c3c8',''],
        'ed2747e7-c86b-48c7-96db-b10c509c27cf':['#f3f3f3',''],
        '912cba99-37cb-41fb-ae2e-2a472200af64':['#a54e79','#fff'],
        '60e848de-41bb-4da4-b201-596107f1904f':['#92c47d',''],
        'c21a4e98-cc3a-41db-ae8c-f197c734dbd9':['#cfe1e3',''],
        '24e00980-9a93-496c-b422-7b17a9ddfc2a':['#fff',''],
    }
    export const mapInternalStatus = {
        '154dcbf5-2ee8-b60d-9f0d-3709944337bd': 'Pending For Approval',
        '3f23bff3-97b9-4b5c-bda8-642ece31c698': 'Pending For Order Confirmation',
        'ffb4f463-33f1-4d05-9575-413f9f58cde7': 'Order Not Ready',
        '957e2962-ab02-4ceb-a57e-04bff9003682': 'Under Pickup Process',
        'fc1a6143-389e-4474-8404-248b27af9867': 'Ready For Pickup',          //Tempo is Ready to go
        '98d24789-d38d-4426-b6bc-1be53a18fb80':'Approval',
        '154dcbf5-2ee8-b60d-9f0d-4709944337bd':'Vehicle Assignment',
        'ccefb0de-fc2b-4a46-8e3f-996f04f40351':'Tempo On The Way To Pickup Load',
        '4b874954-4da5-4002-bbb7-52ba954c9b38':'Tempo Waiting For Loading Material',
        '00fb7496-c2f1-4361-b653-9507419d2096':'Under Billing Process',
        '15fae42a-f0d7-4f84-a995-a2d833864cbe':'Under Verification At Pickup City Warehouse',
        '0d61b7c8-c508-42b4-8da6-ef087e68ea05':'On The Way To Pickup City Warehouse',
        'b3dc515a-9757-4f04-90c9-72860f32b4b3':'Waiting For Departure',       //Ready For Deparature
        'bcd55c8e-76f1-410b-ae50-51931ed987bf':'On The Way To Drop City Warehouse',
        'ea40091b-fb89-4774-ab6d-ec34e638957e': 'At Destination City Warehouse',
        'ed2747e7-c86b-48c7-96db-b10c509c27cf':'Completed',
        '912cba99-37cb-41fb-ae2e-2a472200af64':'Rejected',
        '60e848de-41bb-4da4-b201-596107f1904f': 'In Process Of Departure',
        'c21a4e98-cc3a-41db-ae8c-f197c734dbd9': 'Ready For Final Delivery',
        '24e00980-9a93-496c-b422-7b17a9ddfc2a': 'Cancel',
    }
    export const dateOptions = {
        shortcuts: [
            {   text: 'Today',
                value () {
                    const end = new Date();
                    const start = new Date();
                    return [start, end];
                }
            },
            {  text: 'Yesterday',
                value () {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                    end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
                    return [start, end];
                }
            },
            {   text: 'Last 7 days',
                value () {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    return [start, end];
                }
            },
            {   text: 'Last 30 days',
                value () {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    return [start, end];
                }
            },
            {   text: 'This Month',
                value () {
                    var start = moment().startOf('month').format('DD/MM/YYYY')
                    var end = moment().endOf('month').format('DD/MM/YYYY')
                    return [start, end];
                }
            },
            {   text: 'Last Month',
                value () {
                    var start = moment().subtract(1, 'month').startOf('month').format('DD/MM/YYYY')
                    var end = moment().subtract(1, 'month').endOf('month').format('DD/MM/YYYY')
                    return [start, end];
                }
            }
        ]
    }

    export const nestedHeaders = {
    addressesTable : [ [{label: 'List of Addresses', colspan: 3}], ['Sr. no','Address', 'Action'] ],
    contactsTable : [ [{label: 'List of Contact Persons', colspan: 4}], ['Person Name', 'Mobile', 'Type', 'Action'] ],
    companyUsersTable :[[{label: 'List of Company Users', colspan: 4}], ['User Name', 'Mobile', 'Email', 'Action'] ],
    trucksTable : [ [{label: 'List of Trucks', colspan: 3}], ['Truck Number', 'Capacity', 'Action'] ],
    routesTable : [ [{label: 'List of Routes', colspan: 3}], ['From City', 'To City', 'Action'] ],
    temposTable : [ [
        {label: 'List of Tempos',
        colspan: 3}],
      ['Tempo Number', 'Capacity', 'Type', 'No. of Booking', 'Status', 'Action'] ],
    driversTable : [ [{label: 'List of Drivers', colspan: 5}], ['Name', 'Mobile', 'Type', 'Status', 'Action'] ],
    }
    export function hotSettingsExcelOrders(colWidths = [], self, component='hotTableComponent', screen){
      let hotSettings = {
        data: null,
        readOnly: true,
        hiddenColumns: {columns: []},
        fillHandle: false,
        copyPaste: false,
        licenseKey: "non-commercial-and-evaluation",
        autoRowSize: false,
        autoColumnSize: false,
        colWidths: colWidths,
        className: "htCenter htMiddle",
        filters: true,
        dropdownMenu: ['filter_by_condition', 'filter_operators', 'filter_by_condition2', 'filter_by_value', 'filter_action_bar'],
        columnSorting: { sortEmptyCells: true },
        cell: [],
        afterSelectionEnd: (row, column, row2, column2, selectionLayerLevel) => {
          self.calculateTotalWeight()
        },
        beforeRender: (...args) => {
          // console.log('beforeRender start ' + screen)
          Object.keys(self.elapsedInterval[screen]).forEach(k => clearInterval(self.elapsedInterval[screen][k]))
          // console.log('beforeRender finished ' + screen)
        },
        afterChange: (changes, source) => {
          if(changes){
            changes.forEach(([row, prop, oldValue, newValue]) => {
              let col = self.$refs[component].hotInstance.propToCol(prop)
              if(source === 'revert' || oldValue === newValue || !newValue || self.columns[col].hasOwnProperty('component')) return
              self.confirmObj = {row: row, prop: prop, col: col, oldValue: oldValue, newValue: newValue}
              console.log('oldValue', oldValue, 'newValue', newValue, source)
              self.confirmDialog = true
            });
          }
        },
      }
      return hotSettings
    }
    export function generateHotSettings(colWidths = [], nestedHeaders = undefined){
        let hotSettings = {
            data: null,
            readOnly: true,
            fillHandle: false,
            copyPaste: false,
            licenseKey: "non-commercial-and-evaluation",
            autoRowSize: false,
            autoColumnSize: false,
            colWidths: colWidths,
            className: "htCenter htMiddle",
            filters: true,
            dropdownMenu: ['filter_by_condition', 'filter_operators', 'filter_by_condition2', 'filter_by_value', 'filter_action_bar'],
            columnSorting: { sortEmptyCells: true },
            nestedHeaders: nestedHeaders
        }
        return hotSettings
    }

    export function roughtOfOrder(order){
        let orderDetails = order.orderDetails
        let pickupCity = orderDetails&&orderDetails.pickupPoint&&orderDetails.pickupPoint.pickupPartyId?
            orderDetails.pickupPoint.city:order.pickuppartyobject.address[0].city
        let dropCity = orderDetails&&orderDetails.dropPoint&&orderDetails.dropPoint.dropPartyId?
            orderDetails.dropPoint.city:order.droppingpartyobject.address[0].city
        return pickupCity + '-' + dropCity
    }
    export function getPickupCity(order){
        let orderDetails = order.orderDetails;
        let pickupCity = orderDetails&&orderDetails.pickupPoint&&orderDetails.pickupPoint.pickupPartyId?
            orderDetails.pickupPoint.city:order.pickuppartyobject.address[0].city;
        return pickupCity;
    }
    export function getDropCity(order){
        let orderDetails = order.orderDetails;
        let dropCity = orderDetails&&orderDetails.dropPoint&&orderDetails.dropPoint.dropPartyId?
          orderDetails.dropPoint.city:order.droppingpartyobject.address[0].city
        return dropCity;
    }

export const stageOptions = {
    '154dcbf5-2ee8-b60d-9f0d-3709944337bd': [{id: '98d24789-d38d-4426-b6bc-1be53a18fb80', name:'approved'},
                                             {id: '912cba99-37cb-41fb-ae2e-2a472200af64', name:'rejected'}],
    '98d24789-d38d-4426-b6bc-1be53a18fb80': [{id: '154dcbf5-2ee8-b60d-9f0d-4709944337bd', name:'Vehicle Assignment'},
                                             {id: '98d24789-d38d-4426-b6bc-1be53a18fb80', name:'approved'},
                                             {id: '154dcbf5-2ee8-b60d-9f0d-3709944337bd', name:'pending for approval'}],
    'all': [
        {
            id: "154dcbf5-2ee8-b60d-9f0d-3709944337bd",
            name: "pending for approval"
        },
        {
            "id": "98d24789-d38d-4426-b6bc-1be53a18fb80",
            "name": "approved"
        },
        {
            "id": "154dcbf5-2ee8-b60d-9f0d-4709944337bd",
            "name": "Vehicle Assignment"
        },
        {
            "id": "ccefb0de-fc2b-4a46-8e3f-996f04f40351",
            "name": "Tempo On The Way To Pickup Load"
        },
        {
            "id": "4b874954-4da5-4002-bbb7-52ba954c9b38",
            "name": "Tempo Waiting For Loading Material"
        },
        {
            "id": "00fb7496-c2f1-4361-b653-9507419d2096",
            "name": "Under Billing Process"
        },
        {
            "id": "0d61b7c8-c508-42b4-8da6-ef087e68ea05",
            "name": "On The Way To Pickup City Warehouse"
        },
        {
            "id": "bcd55c8e-76f1-410b-ae50-51931ed987bf",
            "name": "On The Way To Drop City Warehouse"
        },
        {
            "id": "ea40091b-fb89-4774-ab6d-ec34e638957e",
            "name": "At Destination City Warehouse"
        },
        {
            "id": "912cba99-37cb-41fb-ae2e-2a472200af64",
            "name": "rejected"
        },
        {
            "id": "24e00980-9a93-496c-b422-7b17a9ddfc2a",
            "name": "Cancel"
        },
        {
            "id": "ed2747e7-c86b-48c7-96db-b10c509c27cf",
            "name": "Completed"
        },
        {
            "id": "60e848de-41bb-4da4-b201-596107f1904f",
            "name": "In Process Of Departure"
        }
    ]
}

export const orderPriorityColors = {
    0 : ['rgba(0,0,255,1)', 'rgba(0,0,255,0.5)'],               //[full opaque(1) , partial transparent(0.3)]
    1 : ['rgba(128,128,128,1)', 'rgba(128,128,128,0.5)'],
    2 : ['rgba(255,0,0,1)', 'rgba(255,0,0,0.5)'],

}


export function evaluateStatus(order) {
    let status = 'Unknown'

    if(order.internalstatus === Constants.internalStatus.pendingForApproval) {
        status = 'Pending For Approval'
    }else if(order.internalstatus === Constants.internalStatus.approval &&
             order.orderDetails.pickupConfirmation === 'Awaiting') {
        status = 'Order Details Confirmation Pending'
    }else if(order.internalstatus === Constants.internalStatus.approval &&
             order.orderDetails.pickupConfirmation === 'Done' &&
             !order.orderDetails.orderReadiness.isOrderReady) {
        status = 'Order Not Ready'
    }else if(order.internalstatus === Constants.internalStatus.approval &&
             !order.orderDetails.lrObject.isEmailSent &&
             order.orderDetails.orderReadiness.isOrderReady) {
        status = 'Pending For Pickup Email'
    }else if(order.internalstatus === Constants.internalStatus.approval &&
             order.orderDetails.lrObject.isEmailSent &&
             !order.orderDetails.pickupVehicleAssignId) {
        status = 'Waiting For Pickup'
    }else if(order.internalstatus === Constants.internalStatus.approval &&
             order.orderDetails.pickupVehicleAssignId) {
        status = 'Tempo Preparing For Pickup Material'
    }else if(order.internalstatus === Constants.internalStatus.tempoOnTheWayToPickupLoad) {
        status = 'Tempo On The Way To Pickup Load'
    }else if(order.internalstatus === Constants.internalStatus.tempoWaitingForLoadingMaterial) {
        status = 'Tempo Waiting For Loading Material'
    }else if(order.internalstatus === Constants.internalStatus.underBillingProcess) {
        status = 'Under Billing Process'
    }else if(order.internalstatus === Constants.internalStatus.onTheWayToPickupCityWarehouse) {
        status = 'On The Way To Pickup City Warehouse'
    }else if(order.internalstatus === Constants.internalStatus.inProcessOfDeparture &&
             !order.orderDetails.loadedInTruck) {
        status = 'In Process Of Departure'
    }else if(order.internalstatus === Constants.internalStatus.inProcessOfDeparture &&
             order.orderDetails.loadedInTruck &&
             order.orderDetails.transportVehicleAssignId) {
        status = 'Waiting For Depart'
    }else if(order.internalstatus === Constants.internalStatus.onTheWayToDropCityWarehouse) {
        status = 'On The Way To Drop City Warehouse'
    }else if(order.internalstatus === Constants.internalStatus.atDestinationCityWarehouse) {
        status = 'At Destination City Warehouse'
    }else{
        status = order.internalStatus.name
    }

    return status
}
